var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-md-auto order-3 order-md-2"},[_c('div',{staticClass:"v-navbar-navigation mt-2 py-2 d-flex justify-content-start"},[_c('nav',{staticClass:"d-flex justify-content-sm-around"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }